/**
 * The method-URL builder and Frappe's envelope check, extracted from `bosun.ts` so
 * `frappeSession.ts` can reach them without an import cycle (`bosun.ts` imports the session
 * module for its retry, so the session module must not import `bosun.ts` back).
 *
 * Nothing here knows about auth, roles or hooks — it is URL construction and error detection.
 */

import { BosunApiError, parseServerMessages } from './errors'

/** THREE `quoflow` segments. Verified against rfqdev.etoserp.com, 2026-08-04. */
export const API_NS = 'quoflow.quoflow.quoflow.api'

export function methodUrl(module: string, method: string): string {
  return `/api/method/${API_NS}.${module}.${method}`
}

interface FrappeFailure {
  exc_type?: string
  exception?: string
  _server_messages?: string
}

/** Frappe reports some failures with a 200 body, so status alone is not enough. */
export function assertOk(status: number, body: unknown, statusText: string): void {
  const fail = body as FrappeFailure | null
  const hasExc = !!fail && typeof fail === 'object' && ('exc_type' in fail || 'exception' in fail)
  if (status >= 200 && status < 300 && !hasExc) return

  const messages = parseServerMessages(fail?._server_messages)
  if (!messages.length && fail?.exception) messages.push(fail.exception)
  throw new BosunApiError(status, fail?.exc_type, messages, `${status} ${statusText}`)
}
